import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FilterPipe } from 'src/app/shared/pipes/filter.pipe';
import { UtilService } from 'src/app/shared/services/util.service';
import { ConsentGoalsModule } from '../../shared/components/consent-goals/consent-goals.module';
import { ProcessConfigurationModule } from '../../shared/components/process-configuration/process-configuration.module';
import { ProcessUserListModalModule } from '../../shared/modals/process-user-list/process-user-list.module';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { AttributesService } from '../attributes.service';
import { ProcessesService } from '../processes.service';
import { ManageQuestionGroupComponent } from './manage-question-group/manage-question-group.component';

import { ManageVersionPage } from './manage-version.page';
import { ConfigurationBooleanValuesPageModule } from './processes-questions-configuration/question-configuration/boolean-values/configuration-boolean-values.module';
import { QuestionAttributesComponent } from './processes-questions-configuration/question-configuration/question-attributes/question-attributes.component';
import { QuestionConfiguration } from './processes-questions-configuration/question-configuration/question-configuration.component';
import { ConfigurationValuesRulingPageModule } from './processes-questions-configuration/question-configuration/values-ruling/configuration-values-ruling.module';
import { QuestionGroupAttributesComponent } from './processes-questions-configuration/question-group/question-group-attributes/question-group-attributes.component';
import { QuestionGroupComponent } from './processes-questions-configuration/question-group/question-group.component';
import { SelectNumberComponent } from 'src/app/shared/modals/select-number/select-number.component';
import { SelectNumberModule } from 'src/app/shared/modals/select-number/select-number.module';
import { ProcessConfigModalModule } from 'src/app/shared/components/process-config-modal/process-config-modal.module';
import { ConfigureThreesixtyLimitModule } from 'src/app/shared/modals/configure-threesixty-limit/configure-threesixty-limit.module';
import { AttributeQuestionTitleComponent } from './question-configuration/attribute-question-title/attribute-question-title.component';
import { AttributesConfigurationComponent } from './question-configuration/attribute-question-title/attributes-configuration/attributes-configuration.component';
import { ProcessesFlagsComponent } from './processes-flags/processes-flags.component';
import { ProcessesConfigurationsComponent } from './processes-configurations/processes-configurations.component';
import { ProcessesQuestionsConfigurationComponent } from './processes-questions-configuration/processes-questions-configuration.component';

const routes: Routes = [{
    path: '',
    component: ManageVersionPage
}];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        ProcessUserListModalModule,
        ConfigurationBooleanValuesPageModule,
        ConfigurationValuesRulingPageModule,
        ReactiveFormsModule,
        ConsentGoalsModule,
        ProcessConfigurationModule,
        ProcessConfigModalModule,
        SelectNumberModule,
        ConfigureThreesixtyLimitModule,
    ],
    declarations: [
        ManageVersionPage,
        QuestionConfiguration,
        QuestionGroupComponent,
        ManageQuestionGroupComponent,
        FilterPipe,
        QuestionGroupAttributesComponent,
        QuestionAttributesComponent,
        AttributeQuestionTitleComponent,
        AttributesConfigurationComponent,
        ProcessesFlagsComponent,
        ProcessesConfigurationsComponent,
        ProcessesQuestionsConfigurationComponent,
    ],
    providers: [
        ProcessesService,
        AttributesService,
        UtilService
    ]
})
export class ManageVersionModule {
}
